import { ImagesTypeEnum } from '../../components/common/imagesField/ImagesField';

export const SET_BLOG_GALLERY_FILES_MOBILE = 'SET_BLOG_GALLERY_FILES_MOBILE';
export const SET_BLOG_GALLERY_FILES = 'SET_BLOG_GALLERY_FILES';

export const setBlogGalleryFiles = (
  data: Array<File>,
  imagesType: ImagesTypeEnum = ImagesTypeEnum.DESKTOP
) => ({
  type:
    imagesType === ImagesTypeEnum.DESKTOP
      ? SET_BLOG_GALLERY_FILES
      : SET_BLOG_GALLERY_FILES_MOBILE,
  payload: data,
});
